module.exports = __webpack_public_path__ + "img/light-mud-decal-28.24137897.png";